export default {
  MYDETAILS: ['profile', 'acceptance', 'passport', 'Profile Photo'],
  BACKGROUND: ['profile', 'background', 'acceptance', 'passport', 'Profile Photo'],
  ACADEMIC: ['profile', 'background', 'academic', 'acceptance', 'passport', 'Profile Photo'],
  QUESTIONS: ['profile', 'background', 'academic', 'questions', 'acceptance', 'passport', 'Profile Photo'],
  SUBMIT: ['profile', 'background', 'academic', 'questions', 'submit', 'acceptance', 'passport', 'Profile Photo'],
  TRANSCIPTS: ['profile', 'background', 'academic', 'questions', 'submit', 'acceptance', 'passport', 'unofficial-transcripts', 'statement', 'loa', 'Profile Photo']
};
